<template>
  <div class="fixedBtnBox" :class="{ 'is-fixed': isFixed }" ref="fixedBtnBox">
    <div class="fixedBtn" @mouseenter="toggleBubble1()" @mouseleave="hover = showBubble1"
      :style="{ background: hover ? '#32a89e' : '#fff' }" ref="fixedBtn">
      <img class="fixedImg" v-show="hover" src="@/assets/images/icon/whiteCustom.png" alt="" />
      <img class="fixedImg" v-show="!hover" src="@/assets/images/icon/blackCustom.png" alt="" />
      <div class="btn-text">售前咨询</div>
      <div class="bubble" :class="showBubble1 && 'show'" ref="bubble1">
        <div>售前</div>
        <div>咨询电话</div>
        <div>400-966-5960</div>
        <div>业务咨询</div>
        <div @click="navTo('/consult')">
          问题留言，我们会尽快联系您
          <el-icon>
            <ArrowRight></ArrowRight>
          </el-icon>
        </div>
        <!-- 气泡三角形 -->
        <div class="bubble-arrow"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { navTo } from "@/utils/util";
import { ref, watch, onMounted, onBeforeUnmount } from "vue";

const props = defineProps({
  isFixed: Boolean,
});
const hover = ref(false);
const isAnimating = ref(false);
const showBubble1 = ref(false);
const showBubble2 = ref(false);
const fixedBtnBox = ref(null);
const fixedBtn = ref(null);
const bubble1 = ref(null);
var timeout1 = null;

const toggleBubble1 = () => {
  clearTimeout(timeout1);
  showBubble1.value = true;
  hover.value = true;
  timeout1 = setTimeout(() => {
    showBubble1.value = false;
    hover.value = false;
  }, 5000);
};

const handleClickOutside = (event) => {
  if (
    fixedBtn.value &&
    !fixedBtn.value.contains(event.target) &&
    bubble1.value &&
    !bubble1.value.contains(event.target)
  ) {
    showBubble1.value = false;
    hover.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

watch(
  () => props.isFixed,
  (newVal) => {
    isAnimating.value = true;
    setTimeout(() => {
      showBubble1.value = false;
      showBubble2.value = false;
      isAnimating.value = false;
    }, 300);
  }
);
</script>
<style lang="scss" scoped>
.fixedBtnBox {
  position: absolute;
  right: 3rem;
  top: 40rem;
  z-index: 9;
  transition: all 0.3s ease;

  &.is-fixed {
    position: fixed;
    top: 40%;

    .fixedBtn {
      box-shadow: 0px 4px 10px #0000001a;

      .btn-text {
        display: none;
      }

      img {
        margin-bottom: 0;
      }
    }
  }

  .fixedBtn {
    position: relative;
    padding: 0.5rem;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #424242;
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.5rem;
    margin-bottom: 2.25rem;
    cursor: pointer;
    transition: all 0.3s ease;

    .fixedImg {
      width: 3rem;
      height: 3rem;
      transition: all 0.3s ease;
    }

    .btn-text {
      writing-mode: vertical-lr;
    }
  }

  .bubble.show {
    opacity: 1;
    transform: translateX(0);
    pointer-events: all;
  }

  .bubble {
    pointer-events: no;
    position: absolute;
    right: 5rem;
    top: 1rem;
    transform: translateY(-50%);
    border-radius: 0.25rem;
    padding: 0.75rem 1rem;
    background: #fff;
    box-shadow: 0px 4px 10px #0000001a;
    opacity: 0;
    transition: all 0.3s ease;
    transform: translateX(10px);
    pointer-events: none;

    /* 气泡三角形样式 */
    .bubble-arrow {
      position: absolute;
      right: -0.5rem;
      /* 向右偏移一半宽度 */
      top: 20%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 0.5rem solid transparent;
      border-bottom: 0.5rem solid transparent;
      border-left: 0.5rem solid #fff;
      /* 白色与气泡背景一致 */
      filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.1));
      /* 给三角形添加阴影 */
    }

    >div {
      white-space: nowrap;
      writing-mode: horizontal-tb;
      letter-spacing: 2px;
    }

    >div:first-of-type {
      color: #888888;
      font-weight: 400;
      font-size: 0.875rem;
      margin-bottom: 0.5rem;
    }

    >div:nth-child(2) {
      color: #424242;
      font-weight: 500;
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }

    >div:nth-child(3) {
      color: #32a89e;
      font-weight: 500;
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    >div:nth-child(4) {
      color: #424242;
      font-weight: 500;
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }

    >div:nth-child(5) {
      color: #888888;
      font-weight: 500;
      font-size: 0.875rem;
      display: flex;
      align-items: center;
    }
  }
}

// @media(max-width: 768px) {
//   .fixedBtnBox {
//     right: 1rem;
//   }

//   .is-fixed {
//     right: 1rem;

//     .fixedBtn {
//       width: 5rem !important;
//       height: 5rem !important;
//       padding: 0 !important;
//       justify-content: center;
//       box-sizing: border-box;

//       img {
//         margin-bottom: 0;
//       }
//     }
//   }
// }</style>
